import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { prop } from 'js/utils/ramda.util';
import { LIVE_GAMES_REDUCER } from 'js/store/constants';
import { storageService } from 'js/services/storage.service';
import { WebSocketService } from 'js/services/webSocket.service';
import { useCustomSelector, useAppSelector } from 'js/store/hooks';

import * as actions from '../store/actions';

export const useLiveGamesCreateWS = () => {
    const dispatch = useDispatch();
    const liveEndpointUrl = useAppSelector(prop('liveEndpointUrl'));
    const socket = useCustomSelector(LIVE_GAMES_REDUCER, prop('socket'));
    const isNeedToStart = useCustomSelector(LIVE_GAMES_REDUCER, prop('isNeedToStart'));

    useEffect(() => {
        if (!socket && isNeedToStart) {
            const localLiveEndpointUrl = storageService.local.getItem('liveEndpointUrl');

            dispatch(actions.setSocket(new WebSocketService({ apiURL: localLiveEndpointUrl || liveEndpointUrl })));
        }
    }, [socket, liveEndpointUrl, dispatch, isNeedToStart]);
};
